import data_control from "../../../engines/libs/data_control";
import { pawnShopObjPigmentCountAry, pawnShopObjQualityColorAry, pawnShopObjQualityExplainAry } from "./config/pawnShopConfig";
import { pawnShopGameObjI } from "./const/pawnShopConst";

const {ccclass, property} = cc._decorator;

@ccclass
export default class pawnShopGameQuality extends cc.Component {

    @property({type:cc.Label,tooltip:"品质文本"})
    qualityLb:cc.Label = null;

    @property({type:cc.Label,tooltip:"预估文本"})
    lb_Estimate:cc.Label = null;

    @property({type:cc.Label,displayName:"分解数量文本"})
    lb_Pigment:cc.Label = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    obj:pawnShopGameObjI = null;

    onClickBg(){
        this.node.destroy();
        this.node.removeFromParent();
    }

    bindData(obj:pawnShopGameObjI){
        this.obj = obj;
        this.updateDialog();
    }

    updateDialog(){
        this.lbName.string = this.obj.name;
        this.qualityLb.node.color = pawnShopObjQualityColorAry[this.obj.quality];
        this.qualityLb.string = `${pawnShopObjQualityExplainAry[this.obj.quality]}`;
        this.lb_Estimate.string = data_control.getNumberFormat(this.obj.price);
        let resolveCount:number = pawnShopObjPigmentCountAry[this.obj.quality];
        this.lb_Pigment.string = `×${resolveCount}`;
    }

}
